const development = {
  SERVER_URL: 'http://localhost:4000'
}

const production = {
  SERVER_URL: 'https://server.talklearn.co'
}

export default __DEV__ ? development : production
